import { Subscription } from 'rxjs';
import { PostService } from '../../Services/post.service';
import { contentLists } from '../../core-content-manager/contentForms';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetService } from '../../Services/get.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SaveChangesComponent } from '../../core-content-manager/modals/save-changes/save-changes.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { SuccessComponent } from '../../core-content-manager/modals/success/success.component';
import { ErrorsComponent } from '../../core-content-manager/modals/errors/errors.component';
import { ThisReceiver } from '@angular/compiler';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
})
export class UserDetailsComponent implements OnInit, OnDestroy{
  formData: FormData = new FormData();
  imageSizeError = new Map();
  getRecordLink: string;
  recordData: any;
  imageSrc = new Map();

  public mainForm: FormGroup;
  id: any;
  fieldsCtrls = {};
  imageUrl = environment.imgUrl;
  userDetails;
  userId: string;

  showProfileInput: boolean = false;
  showPasswordInput: boolean = false;
  contentTypeData = contentLists.admins;
  userLink = contentLists.admins.link;
  postEditLink;
  routeSubscription= new Subscription();
  action;
  backendError:string;
  userDetailsSubscription = new Subscription();
 usersSubmitSubscription = new Subscription();
  // fields;
  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private post: PostService,
    private service: GetService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.renderPage();
  }

  ngOnInit(): void {
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.renderPage();
      }
    });

  }
renderPage(){
  this.spinner.show();
    this.action = this.activatedRoute.snapshot.paramMap.get('action');
    this.userId = this.activatedRoute.snapshot.paramMap.get('id');
    this.postEditLink = contentLists.admins.postEditLink[this.action];
    this.createForm(this.contentTypeData[this.action] );
    this.getRecordData();
    setTimeout(() => {

      this.spinner.hide();
    }, 1000);
}
  createForm(fields) {
    let is_required;
    for (let f of fields) {
      if (f.required) {
        is_required = Validators.required;
      } else {
        is_required = null;
      }

      this.formData.append(f.name,f.value ||'' );
      this.fieldsCtrls[f.name] = new FormControl(f.value||'', is_required);

      if (f.type == 'file') {
        this.imageSrc[f.name] = f.value;
        this.imageSizeError[f.name] = false;
      }
    }
  }
  getRecordData() {
   this.userDetailsSubscription= this.service.get(this.userLink + '/' + this.userId).subscribe((user) => {

      this.mainForm = new FormGroup(this.fieldsCtrls);
      this.recordData = user.response.data;


       this.mainForm.patchValue(this.recordData);
      this.renderingFormImages();
    });
  }

  submit() {
    this.spinner.show();

    let fields = [];

    fields = this.contentTypeData[this.action];
    var value;
    for (let f of fields) {
      if (f.type != 'file') {
        value = this.mainForm.get(f.name).value;
        this.formData.set(f.name, value);
      }
    }

    this.usersSubmitSubscription = this.post.submit(this.postEditLink, this.formData).subscribe(
      (res) => {
        this.mainForm.patchValue(res.response.data);
        this.dialog.open(SuccessComponent);
      },
      (err) => {

        if( err.error.errors.password){
        this.backendError = err.error.errors.password
        this.dialog.open(ErrorsComponent, {
          data: this.backendError,
        });
      }else{
        this.backendError = err.error.errors.new_password
        this.dialog.open(ErrorsComponent, {
          data: this.backendError,
        });
      }

      }
    );
    setTimeout(() => {
      this.spinner.hide();
    }, 800);
  }
  openDialog() {
    this.mainForm.markAllAsTouched();

    if (this.mainForm.valid) {
      const dialogref = this.dialog.open(SaveChangesComponent, {
        data: 'Are You sure you want to save edits?',
      });
      dialogref.afterClosed().subscribe((reply) => {
        if (reply) {
          this.submit();
        }
      });
    } else {
    }
  }

  renderingFormImages() {
    for (let fieldName in this.imageSrc) {
      this.imageSrc[fieldName] = this.imageUrl + this.recordData[fieldName];
    }
  }
  triggerClick(fieldID) {
    document.getElementById(fieldID).click();
  }

  upload(event, fieldName) {
    // this.progress = 1;
    let file;
    let fileSize;
    const files: File = event.target.files;
    file = files[0];

    fileSize = Math.round(file.size / 1024);
    let vaildSize = fileSize <= 1024;

    const reader = new FileReader();

    if (event.target.files.length && vaildSize) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imageSizeError[fieldName] = false;
        this.imageSrc[fieldName] = reader.result as string;

        this.formData.set(fieldName, event.target.files[0]);
      };
    } else {
      this.imageSizeError[fieldName] = true;
    }
  }

  fillFormData() {
    let field;
    for (field in this.recordData) {
      if (!Array.isArray(this.recordData[field])) {
      }
    }
  }
  ngOnDestroy(): void {
      this.userDetailsSubscription.unsubscribe();
      this.routeSubscription.unsubscribe();
      this.usersSubmitSubscription.unsubscribe();
  }
}
